import classNames from 'classnames';
import {ReactElement, useMemo} from 'react';
import {IMaskInput} from 'react-imask';

const phoneNumberRegex = /^\+?[0-9]*$/;

interface PhoneNumberFieldProps {
  name: string;
  value: string;
  onChange: (phone_number: string) => void;
  labelClassName?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  error?: string;
}

export default function PhoneNumberField({
  name,
  value,
  onChange,
  labelClassName,
  label,
  placeholder,
  required = false,
  error,
}: PhoneNumberFieldProps): ReactElement {
  const hasError = useMemo(() => !!error, [error]);

  return (
    <label className={labelClassName}>
      {label && <span>{label}</span>}
      <IMaskInput
        mask={phoneNumberRegex}
        value={value}
        type="tel"
        onAccept={onChange}
        name={name}
        placeholder={placeholder || ''}
        required={required}
        className={classNames('form__element', {
          'form__element-error': hasError,
        })}
      />
      {hasError && <p className="error-msg">{error}</p>}
    </label>
  );
}
